export const environment = {
  production: false,
  apiUrl: 'https://unuxxto90f.execute-api.sa-east-1.amazonaws.com/dev/api',
  baseIndicatorUrl: 'https://dev-app.barberpassapp.com.br',
};